import styled from '../../../../theme'

export const Wrapper = styled.div`
  display: flex;
  padding: 36px;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  min-width: 728px;
  max-width: 800px;
  padding-top: 20px;
  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    width: 100%;
    min-width: unset;
  }
`

/** Nagłówek z przyciskiem zamknięcia (integracja / mapowanie). */
export const Header = styled.div`
  display: flex;
  color: #272728;
  align-items: center;
  justify-content: space-between;
  font-family: Montserrat, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  width: 100%;
`

/** Nagłówek „Nowy plan Booking.com” na cenniku (linia pod tytułem, bez X). */
export const CennikNewPlanTitleHeader = styled.div`
  border-bottom: 1px solid #e0e0e0;
  color: #272728;
  font-family: Montserrat, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  padding-bottom: 12px;
  width: 100%;
`

/** Jak wyżej, ale z miejscem na przycisk zamknięcia (np. mapowanie pokoi Booking). */
export const NewPlanModalHeaderRow = styled.div`
  align-items: center;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  gap: 8px;
  justify-content: space-between;
  padding-bottom: 12px;
  width: 100%;
`

export const NewPlanModalHeaderTitle = styled.div`
  color: #272728;
  flex: 1;
  font-family: Montserrat, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  min-width: 0;
`

/** Nagłówek modala prowizji (mapowanie): tytuł + podtytuł szary + X — jak makieta. */
export const CommissionModalHeadingBlock = styled.div`
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 12px;
  width: 100%;
`

export const CommissionModalHeadingTop = styled.div`
  align-items: flex-start;
  display: flex;
  gap: 8px;
  justify-content: space-between;
`

export const CommissionModalTitle = styled.div`
  color: #272728;
  font-family: Montserrat, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
`

export const CommissionModalSubtitle = styled.div`
  color: #858585;
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  margin-top: 8px;
`

export const Text = styled.div`
  color: #272728;
  font-family: Montserrat, sans-serif;
  margin-top: 15px;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`

export const TextBold = styled.div`
  color: #272728;
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  margin-top: 8px;
  width: 100%;
`

export const AnnouncementBox = styled.div`
  align-items: center;
  background: #fffbeb;
  border: 1px solid #ffa800;
  border-radius: 4px;
  display: flex;
  gap: 8px;
  margin-top: 16px;
  padding: 4px 8px;
  width: 100%;
`

export const AnnouncementText = styled.div`
  color: #973c00;
  flex: 1;
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 36px;
  margin-top: 24px;
  max-height: 48vh;
  // overflow-y: auto;
  padding-right: 36px;
  width: 100%;
  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    padding-right: 0;
  }
`

export const RadioWrapper = styled.div<{ $selected?: boolean }>`
  align-items: flex-start;
  background-color: #fff;
  border: 1px solid ${({ $selected }) => ($selected ? '#00A541' : '#d7d7d7')};
  border-radius: 6px;
  display: flex;
  padding: 8px;
  width: 100%;
  max-height: 319px;
  overflow: hidden;
`

export const RadioDesct = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  margin-left: 25px;
  width: 100%;
`

export const DescTitle = styled.div`
  color: #272728;
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  margin-bottom: 5px;
`

export const YesOptionTitleRow = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: space-between;
  margin-bottom: 21px;
  width: 100%;
`

export const OptionsSection = styled.div`
  max-height: 692px;
`

export const YesOptionTitle = styled(DescTitle)`
  flex: 1 1 auto;
  margin-bottom: 0;
  min-width: 0;
`

export const RecommendedBadge = styled.span`
  background: #e8f5e9;
  border-radius: 4px;
  color: #2e7d32;
  flex-shrink: 0;
  font-family: Montserrat, sans-serif;
  font-size: 10px;
  font-weight: 600;
  line-height: 16px;
  padding: 2px 8px;
  white-space: nowrap;
`

export const PricesSentSection = styled.div`
  margin-top: 16px;
  margin-bottom: 8px;
  width: 100%;
  display: flex;
  gap: 20px;
  flex-direction: column;
`

export const PricesSentTitle = styled.div`
  color: #272728;
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  font-weight: 700;
  line-height: 24px;
  margin-bottom: 4px;
`

export const ReadOnlyPlanRow = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-start;
  width: 100%;
`

export const ReadOnlyPlanName = styled.span`
  color: #272728;
  flex: 0 1 272px;
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 24px;
  min-width: 272px;
`

export const ReadOnlyPlanPercent = styled.span`
  color: #00a541;
  display: inline-block;
  flex-shrink: 0;
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 24px;
  min-width: 56px;
  text-align: right;
`

export const DescText = styled.div`
  color: #272728;
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    line-height: 18px;
  }
`

export const EditablePlan = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 195px;
`
export const EditablePlanRows = styled.div`
  width: 100%;
  max-width: 521px;
`
export const PlanRow = styled.div`
  align-items: flex-end;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: space-between;
  margin-bottom: 14px;
  margin-top: 8px;
  width: 100%;
  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    gap: 0;
  }
`

export const PlanLeft = styled.div`
  align-items: center;
  display: flex;
  flex: 1 1 200px;
  gap: 10px;
  min-width: 0;
  margin-bottom: 20px;
  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    margin-bottom: 0;
  }
`

export const PlanName = styled.span`
  color: #133880;
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
`

export const LogoImg = styled.img`
  flex-shrink: 0;
  display: block;
  height: 22px;
  object-fit: contain;
  width: 22px;
`

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  padding-right: 36px;
`
